import { React } from "react";
import { useTranslation } from "react-i18next";
import DealIcon from "../../layout/left_menu_icons/deal.svg";

export default function HiredCandidatesHeader() {

const { t } = useTranslation();

  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={DealIcon} alt="ni-icon" />
            <h1 style={{marginTop:"10px"}}>
              {t("Hired")}
            </h1>
          </div>
          <div className="subtitle">{t("Recruitment / Hired")}</div>
        </div>
      </header>
    </>
  );
}
